import _taggedTemplateLiteral from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

var _templateObject;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _decorate from "@babel/runtime/helpers/esm/decorate";

var _2 = function _2(t) {
  return t;
},
    _t;
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */


import { html, property, customElement, LitElement } from 'lit-element';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import settings from 'carbon-components/es/globals/js/settings';
import ifNonNull from 'carbon-web-components/es/globals/directives/if-non-null.js';
import styles from "./tag-link.css.js";
var ddsPrefix = ddsSettings.stablePrefix;
var prefix = settings.prefix;
/**
 * Tag Link.
 *
 * @element dds-tag-link
 */

var DDSTagLink = _decorate([customElement("".concat(ddsPrefix, "-tag-link"))], function (_initialize, _LitElement) {
  var DDSTagLink = /*#__PURE__*/function (_LitElement2) {
    _inherits(DDSTagLink, _LitElement2);

    var _super = _createSuper(DDSTagLink);

    function DDSTagLink() {
      var _this;

      _classCallCheck(this, DDSTagLink);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _initialize(_assertThisInitialized(_this));

      return _this;
    }

    return DDSTagLink;
  }(_LitElement);

  return {
    F: DDSTagLink,
    d: [{
      kind: "field",
      decorators: [property({
        reflect: true
      })],
      key: "href",
      value: void 0
    }, {
      kind: "field",
      decorators: [property({
        reflect: true
      })],
      key: "hreflang",
      value: void 0
    }, {
      kind: "field",
      decorators: [property({
        attribute: 'link-role'
      })],
      key: "linkRole",
      value: void 0
    }, {
      kind: "field",
      decorators: [property({
        reflect: true
      })],
      key: "ping",
      value: void 0
    }, {
      kind: "field",
      decorators: [property({
        reflect: true
      })],
      key: "rel",
      value: void 0
    }, {
      kind: "field",
      decorators: [property({
        reflect: true
      })],
      key: "target",
      value: void 0
    }, {
      kind: "method",
      key: "_handleClick",
      value:
      /**
       * Link `href`.
       */

      /**
       * The language of what `href` points to.
       */

      /**
       * The a11y role for `<a>`.
       */

      /**
       * URLs to ping.
       */

      /**
       * The link type.
       */

      /**
       * The link target.
       */

      /**
       * Handles `click` event on the `<a>`.
       */
      // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
      function _handleClick(_) {}
    }, {
      kind: "method",
      key: "render",
      value: function render() {
        var href = this.href,
            hreflang = this.hreflang,
            linkRole = this.linkRole,
            ping = this.ping,
            rel = this.rel,
            target = this.target,
            handleClick = this._handleClick;
        return html(_t || (_t = _2(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      <a\n        id=\"link\"\n        role=\"", "\"\n        class=\"", "--link\"\n        part=\"link\"\n        href=\"", "\"\n        hreflang=\"", "\"\n        ping=\"", "\"\n        rel=\"", "\"\n        target=\"", "\"\n        @click=\"", "\"\n      >\n        <slot></slot>\n      </a>\n    "])), 0, 0, 0, 0, 0, 0, 0, 0)), ifNonNull(linkRole), prefix, ifNonNull(href), ifNonNull(hreflang), ifNonNull(ping), ifNonNull(rel), ifNonNull(target), handleClick);
      }
    }, {
      kind: "field",
      static: true,
      key: "styles",
      value: function value() {
        return styles;
      }
    }]
  };
}, LitElement);
/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */


export default DDSTagLink;